import { loadStripe } from '@stripe/stripe-js';

// Clé PUBLIABLE Stripe (pk_...) — destinée à être exposée côté client.
// Inlinée au build par Vite depuis VITE_STRIPE_PUBLISHABLE_KEY.
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;

// loadStripe est mémoïsé : on l'appelle une seule fois au chargement du module.
export const stripePromise = publishableKey ? loadStripe(publishableKey) : null;
